export default "__VITE_ASSET__zRkG2dgR__"